import { ChangeDetectionStrategy, Component, computed, input, signal } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { BuildStatusModel, SaleStatusModel } from "../new-dwellings-filter.model";

@Component({
    selector: "new-dwellings-filter-sale-build-status",
    imports: [],
    templateUrl: "./new-dwellings-filter-sale-build-status.component.html",
    styleUrl: "./new-dwellings-filter-sale-build-status.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDwellingsFilterSaleBuildStatusComponent {
    filterFormSaleStatus = input.required<FieldTree<SaleStatusModel[]>>();
    filterFormBuildStatus = input.required<FieldTree<BuildStatusModel[]>>();    

    allSelectedSaleStatus = computed(() => {
        const field = this.filterFormSaleStatus();
        return field().value().every((o) => o.selected);
    });

    toggleSelectedSaleStatus(option: SaleStatusModel): void {
        const field = this.filterFormSaleStatus();
        field().value.set(field().value().map((o) => (o.value === option.value ? { ...o, selected: !o.selected } : o)));
    }

    selectAllSaleStatus(): void {
        const field = this.filterFormSaleStatus();
        field().value.update((options) => options.map((o) => ({ ...o, selected: !this.allSelectedSaleStatus() })));
    }

    allSelectedBuildStatus = computed(() => {
        const field = this.filterFormBuildStatus();
        return field().value().every((o) => o.selected);
    });

    toggleSelectedBuildStatus(option: BuildStatusModel): void {
        const field = this.filterFormBuildStatus();
        field().value.set(field().value().map((o) => (o.value === option.value ? { ...o, selected: !o.selected } : o)));
    }

    selectAllBuildStatus(): void {
        const field = this.filterFormBuildStatus();
        field().value.update((options) => options.map((o) => ({ ...o, selected: !this.allSelectedBuildStatus() })));
    }
}
